module.exports = __webpack_public_path__ + "static/media/Image.f0271e12.svg";